import { render, staticRenderFns } from "./ListAccomodationsMobile.vue?vue&type=template&id=6afd6208&"
import script from "./ListAccomodationsMobile.vue?vue&type=script&lang=js&"
export * from "./ListAccomodationsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ListAccomodationsMobile.vue?vue&type=style&index=0&id=6afd6208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports